import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
// import Tabs from '@material-ui/core/Tabs';
// import Tab from '@material-ui/core/Tab';
import { Link } from "react-router-dom";
import Button from '@material-ui/core/Button';
import { Modal } from '@material-ui/core';
// import IconButton from '@material-ui/core/IconButton';
import Login from "../components/Login";
import ClearIcon from "@material-ui/icons/Clear";
import Fab from '@material-ui/core/Fab';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

const { innerWidth } = window;

function getModalStyle() {
    return {
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
    };
}

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    gradientBackground: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        // background: 'linear-gradient(to right, #2926ac 0%, #0a0a0a 100%)',
        transition: '1200ms',
        zIndex: 3,
        opacity: 0.9
    },
    transparentBackground: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        zIndex: 3,
        transition: '1200ms'
    },
    // paper: {
    //     position: 'absolute',
    //     width: theme.spacing.unit * 80,
    //     backgroundColor: theme.palette.background.paper,
    //     boxShadow: theme.shadows[5],
    //     // padding: theme.spacing.unit * 4,
    //     outline: 'none',
    // },
    paper: {
        position: 'absolute',
        // width: theme.spacing.unit * 100,
        width: innerWidth >= 480 ? theme.spacing.unit * 100 : (innerWidth - (theme.spacing.unit * 4)),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        // padding: innerWidth >= 480 ? theme.spacing.unit * 4 : theme.spacing.unit * 2,
        // padding: '10px 32px 10px 32px',
        outline: 'none',
        borderRadius: 5
    },
    margin: {
        margin: theme.spacing.unit,
    },
    // closeButtonFab: {
    //     float: 'right',
    //     marginRight: '-60px',
    //     marginTop: '-60px'
    // },
    button: {
        color: "#FFFFFF",
        borderRadius: 15,
        fontSize: 10
    },
    centerText: {
        textAlign: 'center'
    },
    closeButton: {
        float: 'right',
        //  marginRight: '-25px',
         marginBottom: '-50px'
    },
    closeButtonFab: {
        float: 'right',
         marginRight: '-15px',
          marginTop: '-15px'
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
});

class LaunchHeader extends Component {
    static contextTypes = {
        router: PropTypes.object,
    }

    constructor() {
        super();
        this.state = {
            scrolling: false,
            value: 0,
            menu: 0,
            modelState: false,
            // anchorEl: null,
            mobileMoreAnchorEl: null
        }
    }

    handleMenuClose = () => {
        this.setState({ anchorEl: null });
        this.handleMobileMenuClose();
    };

    handleMobileMenuOpen = event => {
        this.setState({ mobileMoreAnchorEl: event.currentTarget });
    };

    handleMobileMenuClose = () => {
        this.setState({ mobileMoreAnchorEl: null });
    };

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        this.defaultMenu()
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    defaultMenu() {
        let url = window.location.pathname.split('/')[1];
        let menu = url === "alllibraries" ? 1 : url === "fllteams" ? 2 : 0
        this.setState({ menu })
    }

    handleScroll = (event) => {
        if (window.scrollY < 50 && this.state.scrolling === true) {
            this.setState({ scrolling: false });
        }
        else if (window.scrollY > 50 && this.state.scrolling !== true) {
            this.setState({ scrolling: true });
        }
    }

    handleChange = (event, value) => {
        this.setState({
            value: value
        });     
    }

    handleClose = () => {
        this.setState({
            modelState: false
        });
    }

    render() {
        const { classes } = this.props;
        const { mobileMoreAnchorEl } = this.state;
        // const isMenuOpen = Boolean(anchorEl);
        const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);        

        const renderMobileMenu = (
            <Menu
                anchorEl={mobileMoreAnchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={isMobileMenuOpen}
                onClose={this.handleMenuClose}
            >
                <MenuItem onClick={this.handleMobileMenuClose}>                    
                    <Button component={Link} to={`/`} onClick={() => this.setState({ menu: 0 })} color="inherit" style={this.state.menu === 0 ? { borderBottom: "2px solid red", minWidth: 102, textTransform: 'none' } : { opacity: 0.7, minWidth: 102, textTransform: 'none' }}>Home</Button>                    
                </MenuItem>
                <MenuItem onClick={this.handleMobileMenuClose}>                    
                    <Button component={Link} to={`/alllibraries`} onClick={() => this.setState({ menu: 1 })} color="inherit" style={this.state.menu === 1 ? { borderBottom: "2px solid red", minWidth: 102, textTransform: 'none' } : { opacity: 0.7, minWidth: 102, textTransform: 'none' }}>Library</Button>                    
                </MenuItem>
                <MenuItem onClick={this.handleMobileMenuClose}>                    
                    <Button component={Link} to="/fllteams" onClick={() => this.setState({ menu: 2 })} color="inherit" style={this.state.menu === 2 ? { borderBottom: "2px solid red", minWidth: 102, textTransform: 'none' } : { opacity: 0.7, minWidth: 102, textTransform: 'none' }}>FLLTeams</Button>                    
                </MenuItem>
                <MenuItem onClick={this.handleMobileMenuClose}>                    
                    <Button onClick={() => this.setState({ modelState: true })} color="inherit" style={this.state.menu === 3 ? { borderBottom: "2px solid red", minWidth: 102, textTransform: 'none' } : { opacity: 0.7, minWidth: 102, textTransform: 'none' }}>Login</Button>
                </MenuItem>
            </Menu>
        );

        return (
            <div>
                <AppBar position={"fixed"}
                    className={this.state.scrolling ? classes.gradientBackground : classes.transparentBackground}
                >
                    <Toolbar>
                        <Typography variant="h5" color="inherit" className={classes.grow}>
                            <strong>Thunder</strong>Bots
                        </Typography>
                        <div className={classes.sectionDesktop}>
                            <Button component={Link} to={`/`} onClick={() => this.setState({ menu: 0 })} color="inherit" style={this.state.menu === 0 ? { borderBottom: "2px solid red", minWidth: 102, textTransform: 'none' } : { opacity: 0.7, minWidth: 102, textTransform: 'none' }}>Home</Button>
                            <Button component={Link} to={`/alllibraries`} onClick={() => this.setState({ menu: 1 })} color="inherit" style={this.state.menu === 1 ? { borderBottom: "2px solid red", minWidth: 102, textTransform: 'none' } : { opacity: 0.7, minWidth: 102, textTransform: 'none' }}>Library</Button>
                            <Button component={Link} to="/fllteams" onClick={() => this.setState({ menu: 2 })} color="inherit" style={this.state.menu === 2 ? { borderBottom: "2px solid red", minWidth: 102, textTransform: 'none' } : { opacity: 0.7, minWidth: 102, textTransform: 'none' }}>FLLTeams</Button>
                            <Button onClick={() => this.setState({ modelState: true })} color="inherit" style={this.state.menu === 3 ? { borderBottom: "2px solid red", minWidth: 102,textTransform: 'none' } : { opacity: 0.7, minWidth: 102,textTransform: 'none' }}>Login</Button>
                        </div>
                        <div className={classes.sectionMobile}>
                            <IconButton aria-haspopup="true" onClick={this.handleMobileMenuOpen} color="inherit">
                                <MenuIcon />
                            </IconButton>
                        </div>
                    </Toolbar>
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={this.state.modelState}
                        onClose={this.handleClose}
                        disableBackdropClick={true}
                    >
                        <div style={getModalStyle()} className={classes.paper}>
                        <div className={classes.closeButton}>
                                <Fab size="small" color="secondary" aria-label="Add" className={classes.closeButtonFab} onClick={this.handleClose}>
                                    <ClearIcon />
                                </Fab>
                            </div>
                            <Login launchHeaderThis={this} />
                        </div>
                    </Modal>
                </AppBar>
                {renderMobileMenu}
            </div>
        );
    }
}

LaunchHeader.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LaunchHeader);